<template>
  <div>
    آیا حمایت را تایید می‌کنید؟

    <b-form-radio-group v-model="review.isApproved">
      <b-form-radio class="ms-1" :value="true">بله</b-form-radio>
      <b-form-radio :value="false">خیر</b-form-radio>
    </b-form-radio-group>
    <div v-if="review.isApproved">
      <br />
      حداقل حمایت مورد نظر (تومان):
      <b-form-input
        type="number"
        style="width: 350px"
        v-model="review.minSupport"
      ></b-form-input>
      <span class="pa-2 c-purple" v-if="review.minSupport"
        >{{ Number(review.minSupport).toLocaleString() }} تومان</span
      >
      <br />
      <br />
      حداکثر حمایت مورد نظر (تومان):
      <b-form-input
        type="number"
        style="width: 350px"
        v-model="review.maxSupport"
      ></b-form-input>
      <span class="pa-2 c-purple" v-if="review.maxSupport"
        >{{ Number(review.maxSupport).toLocaleString() }} تومان</span
      >
    </div>
    <div class="py-10">
      <v-btn
        elevation="0"
        :disabled="
          review.isApproved == null ||
          (review.isApproved && (!review.minSupport || !review.maxSupport))
        "
        class="float-end bc-primary"
        :loading="loading"
        @click="submitReview"
      >
        <v-icon class="white--text pe-2" small>mdi-check-outline</v-icon>
        <span class="white--text">ثبت داوری</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ["type"],
  data() {
    return {
      review: {
        isApproved: null,
      },
      loading: false,
    };
  },
  methods: {
    submitReview() {
      this.loading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/accelerator/review/" + this.type + "/done",
          {
            reviewId: this.$route.params.id,
            isApproved: this.review.isApproved,
            minSupport: this.review.minSupport,
            maxSupport: this.review.maxSupport,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.$router.push("/accelerator/archiveReviews");
          }
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.loading = false;
        });
    },
  },
};
</script>
